import { Button, CircularProgress } from "@mui/material";
import RightArrow from "../Vectors/RightArrow";

const styles = {
  btnStyle: {
    background: "#503DFC",
    textTransform: "capitalize",
    borderRadius: 50,
    textUnderlineOffset: "10px",
    "&.Mui-disabled": {
      background: "#E7E7E7",
      opacity: 1,
      color: "#BCBCBC",
    },
    "&.MuiButtonBase-root:hover": {
      bgcolor: "#503DFC",
    },
  },
};

const DelendSignOnButton = ({ onClick, enableButton, isLoading }) => {
  if (isLoading) {
    return (
      <Button
        disabled={true}
        variant="contained"
        sx={styles.btnStyle}
        fullWidth
        endIcon={<CircularProgress size="26px" />}
      />
    );
  }

  return (
    <Button
      onClick={onClick}
      type="submit"
      disabled={!enableButton}
      variant="contained"
      sx={styles.btnStyle}
      fullWidth
      endIcon={<RightArrow />}
    >
      Criar Conta
    </Button>
  );
};

export default DelendSignOnButton;
